(function() {
  if (window.SWHPackageProductPage) return;

  var cleanups = new Map();
  var STOREFRONT_API_VERSION = '2025-10';

  function parseConfig(section) {
    var configEl = section.querySelector('script[data-swh-package-config]');
    if (!configEl) return null;

    try {
      return JSON.parse(configEl.textContent || '{}');
    } catch (error) {
      return null;
    }
  }

  function initSection(section) {
    if (!section || cleanups.has(section.id)) return;

    var detailUtils = window.SWHProductDetail;
    if (!detailUtils) return;

    var config = parseConfig(section);
    if (!config) return;

    var listeners = [];
    var destroyBackButton = detailUtils.initBackButton(section, {
      selector: '[data-package-back]',
      fallbackAttr: 'data-package-back-fallback'
    });
    var galleryApi = detailUtils.initGallery(section, {
      bodyClass: 'swh-package-gallery-open'
    });
    var selects = Array.prototype.slice.call(section.querySelectorAll('.swh-package-option'));
    var variantInput = section.querySelector('#PackageVariantId-' + config.sectionId);
    var priceEl = section.querySelector('#PackagePrice-' + config.sectionId);
    var inlinePriceEl = section.querySelector('#PackagePriceInline-' + config.sectionId);
    var compareEl = section.querySelector('#PackageComparePrice-' + config.sectionId);
    var compareWrap = section.querySelector('#PackageComparePriceWrap-' + config.sectionId);
    var stickyPrice = section.querySelector('#PackageStickyPrice-' + config.sectionId);
    var submitBtn = section.querySelector('#PackageSubmit-' + config.sectionId);
    var submitText = section.querySelector('#PackageSubmitText-' + config.sectionId);
    var stickySubmitBtn = section.querySelector('.swh-package-sticky-cta__button');
    var availabilityEl = section.querySelector('#PackageAvailability-' + config.sectionId);
    var bundleList = section.querySelector('[data-package-bundle-list]');
    var bundleEmpty = section.querySelector('[data-package-bundle-empty]');
    var variants = Array.isArray(config.variants) ? config.variants : [];
    var stickyBodyClass = 'swh-package-sticky-footer';

    function getStorefrontAccessToken() {
      var featuresEl = document.querySelector('#shopify-features');
      if (!featuresEl) return '';

      try {
        var features = JSON.parse(featuresEl.textContent || '{}');
        return features && features.accessToken ? String(features.accessToken) : '';
      } catch (error) {
        return '';
      }
    }

    function escapeHtml(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function buildBundleCard(component, iconClass) {
      if (!component || !component.productVariant || !component.productVariant.product) return '';

      var variant = component.productVariant;
      var product = variant.product;
      var title = product.title || variant.title || 'Bundel item';
      var variantTitle = variant.title && variant.title !== 'Default Title' ? variant.title : '';
      var image = variant.image || product.featuredImage;
      var imageUrl = image && image.url ? String(image.url) : '';
      var imageMarkup = imageUrl
        ? '<img src="' + escapeHtml(imageUrl + (imageUrl.indexOf('?') === -1 ? '?' : '&') + 'width=200') + '" srcset="' + escapeHtml(imageUrl + (imageUrl.indexOf('?') === -1 ? '?' : '&') + 'width=120') + ' 120w, ' + escapeHtml(imageUrl + (imageUrl.indexOf('?') === -1 ? '?' : '&') + 'width=200') + ' 200w" sizes="80px" alt="' + escapeHtml(image.altText || title) + '" width="200" height="200">'
        : '<div class="swh-package-bundle-card__fallback">Geen foto</div>';
      var variantMarkup = variantTitle
        ? '<p class="swh-package-bundle-card__variant">' + escapeHtml(variantTitle) + '</p>'
        : '';
      var quantityMarkup = component.quantity
        ? '<p class="swh-package-bundle-card__meta">Aantal: ' + escapeHtml(component.quantity) + '</p>'
        : '';
      var url = product.onlineStoreUrl || '';
      var linkMarkup = url
        ? '<a href="' + escapeHtml(url) + '" class="swh-package-bundle-card__link"><span>Bekijk product</span><i class="' + escapeHtml(iconClass) + '" aria-hidden="true"></i></a>'
        : '';

      return [
        '<article class="swh-package-bundle-card">',
        '<div class="swh-package-bundle-card__media">',
        imageMarkup,
        '</div>',
        '<div class="swh-package-bundle-card__body">',
        '<p class="swh-package-bundle-card__title">' + escapeHtml(title) + '</p>',
        variantMarkup,
        quantityMarkup,
        linkMarkup,
        '</div>',
        '</article>'
      ].join('');
    }

    async function loadBundleComponents() {
      if (!bundleList || !config.productHandle) return;

      var accessToken = getStorefrontAccessToken();
      if (!accessToken) return;

      var query = [
        'query BundleComponents($handle: String!) {',
        '  product(handle: $handle) {',
        '    variants(first: 50) {',
        '      nodes {',
        '        id',
        '        requiresComponents',
        '        components(first: 50) {',
        '          nodes {',
        '            quantity',
        '            productVariant {',
        '              id',
        '              title',
        '              image { url altText }',
        '              product {',
        '                title',
        '                handle',
        '                onlineStoreUrl',
        '                featuredImage { url altText }',
        '              }',
        '            }',
        '          }',
        '        }',
        '      }',
        '    }',
        '  }',
        '}'
      ].join('\n');

      try {
        var response = await fetch('/api/' + STOREFRONT_API_VERSION + '/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': accessToken
          },
          body: JSON.stringify({
            query: query,
            variables: { handle: config.productHandle }
          })
        });

        if (!response.ok) return;

        var payload = await response.json();
        var nodes = payload && payload.data && payload.data.product && payload.data.product.variants && payload.data.product.variants.nodes;
        if (!Array.isArray(nodes) || !nodes.length) return;

        var selectedSuffix = '/' + String(variantInput && variantInput.value ? variantInput.value : config.selectedVariantId);
        var bundleVariant = nodes.find(function(node) {
          return node && typeof node.id === 'string' && node.id.endsWith(selectedSuffix);
        }) || nodes.find(function(node) {
          return node && node.requiresComponents && node.components && Array.isArray(node.components.nodes) && node.components.nodes.length;
        });

        var components = bundleVariant && bundleVariant.components && Array.isArray(bundleVariant.components.nodes)
          ? bundleVariant.components.nodes
          : [];

        if (!components.length) return;

        var iconClass = bundleList.getAttribute('data-bundle-link-icon') || 'fa-solid fa-arrow-right';
        var markup = components.map(function(component) {
          return buildBundleCard(component, iconClass);
        }).join('');

        if (!markup) return;

        bundleList.innerHTML = markup;
        bundleList.hidden = false;
        if (bundleEmpty) bundleEmpty.hidden = true;
      } catch (error) {
        return;
      }
    }

    function addListener(target, eventName, handler) {
      if (!target) return;
      target.addEventListener(eventName, handler);
      listeners.push(function() {
        target.removeEventListener(eventName, handler);
      });
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, config.moneyFormat);
      }

      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {
          style: 'currency',
          currency: config.currency
        }).format((Number(cents) || 0) / 100);
      } catch (error) {
        return ((Number(cents) || 0) / 100).toFixed(2) + ' ' + config.currency;
      }
    }

    function getSelectedValues() {
      return selects.map(function(select) {
        return select.value;
      });
    }

    function findVariant() {
      if (!selects.length) {
        return variants.find(function(variant) {
          return String(variant.id) === String(config.selectedVariantId);
        }) || variants[0] || null;
      }

      var selected = getSelectedValues();
      return variants.find(function(variant) {
        if (!variant.options) return false;
        return variant.options.every(function(value, idx) {
          return value === selected[idx];
        });
      });
    }

    function updateUI(variant) {
      if (!variant) return;

      if (variantInput) variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price).replace(/\s?[A-Z]{3}$/, '');
      if (inlinePriceEl) inlinePriceEl.textContent = formatMoney(variant.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price).replace(/\s?[A-Z]{3}$/, '');

      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price).replace(/\s?[A-Z]{3}$/, '');
          if (compareWrap) compareWrap.hidden = false;
          else compareEl.hidden = false;
        } else {
          if (compareWrap) compareWrap.hidden = true;
          else compareEl.hidden = true;
          compareEl.textContent = '';
        }
      }

      [submitBtn, stickySubmitBtn].forEach(function(button) {
        if (!button) return;
        button.disabled = !variant.available;
        button.setAttribute('aria-disabled', String(!variant.available));
      });

      if (submitText) {
        submitText.textContent = variant.available ? 'In winkelmand' : 'Uitverkocht';
      }

      if (stickySubmitBtn) {
        stickySubmitBtn.textContent = variant.available ? 'In winkelmand' : 'Uitverkocht';
      }

      if (availabilityEl) {
        availabilityEl.textContent = variant.available ? 'Op voorraad' : 'Tijdelijk uitverkocht';
        availabilityEl.classList.toggle('is-unavailable', !variant.available);
      }

      if (galleryApi && variant.featured_media && variant.featured_media.id) {
        galleryApi.selectByMediaId(variant.featured_media.id);
      }
    }

    function onChange() {
      updateUI(findVariant());
      loadBundleComponents();
    }

    document.body.classList.add(stickyBodyClass);

    selects.forEach(function(select) {
      addListener(select, 'change', onChange);
    });
    updateUI(findVariant());
    loadBundleComponents();

    cleanups.set(section.id, function() {
      listeners.splice(0).forEach(function(removeListener) {
        removeListener();
      });
      document.body.classList.remove(stickyBodyClass);
      if (galleryApi && typeof galleryApi.destroy === 'function') galleryApi.destroy();
      if (typeof destroyBackButton === 'function') destroyBackButton();
      cleanups.delete(section.id);
    });
  }

  function cleanupSection(section) {
    if (!section) return;
    var cleanup = cleanups.get(section.id);
    if (typeof cleanup === 'function') cleanup();
  }

  function initAllSections() {
    document.querySelectorAll('.shopify-section.product-package').forEach(initSection);
  }

  function onReady() {
    if (!window.SWHProductDetail) {
      window.addEventListener('swh:product-detail:ready', onReady, { once: true });
      return;
    }

    initAllSections();
  }

  document.addEventListener('shopify:section:load', function(event) {
    if (event.target && event.target.classList && event.target.classList.contains('product-package')) {
      initSection(event.target);
    }
  });

  document.addEventListener('shopify:section:unload', function(event) {
    if (event.target && event.target.classList && event.target.classList.contains('product-package')) {
      cleanupSection(event.target);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady, { once: true });
  } else {
    onReady();
  }

  window.SWHPackageProductPage = {
    initSection: initSection,
    cleanupSection: cleanupSection
  };
})();
